
  document.addEventListener('DOMContentLoaded', function() {
    const variantPicker = document.querySelector('variant-picker');
    
    if (variantPicker) {
      variantPicker.addEventListener('change', function(e) {
        const selectedOption = e.target.closest('input[type="radio"]');
        
        if (selectedOption) {
          const optionName = selectedOption.name.split('-')[0];
          const selectedValue = selectedOption.value;
          const marketHandle = "{{ localization.country.market.handle }}";
          
          let displayValue = selectedValue;
          
          if (selectedValue.includes('|')) {
            const parts = selectedValue.split('|');
            const euValue = parts[0].trim();
            const ukValue = parts[1].trim();
            const usValue = parts[2].trim();
            
            if (marketHandle === 'united-kingdom') {
              displayValue = ukValue;
            } else if (marketHandle === 'united-states') {
              displayValue = usValue.replace('US', '').trim();
            } else {
              displayValue = euValue;
            }
          }
          
          // Update the inner .option-value span
          const labels = document.querySelectorAll('[data-variant-picker-option-labels]');
          labels.forEach(label => {
            const optionValueSpan = label.querySelector('.product-variant-picker__option-label .option-value-custom');
            const outerSpan = label.querySelector('.product-variant-picker__option-label span');
            
            if (optionValueSpan && outerSpan && outerSpan.textContent.includes(optionName)) {
              optionValueSpan.textContent = displayValue;
            }
          });
        }
      });
    }
  });
